import PosOrdersTable from './PosOrdersTable';

export default PosOrdersTable;
